let Meridian = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;
    /**
     * 获取经络搜索列表数据
     * @param {any} success
     * @param {any} error
     *
     * 
     */
    this.Meridians = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/Extra/Search/Meridian' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 获取经络分类
     * @param {any} success
     * @param {any} error
     */
    this.Categorys = function (success, error) {
        var url = ServiceBaseAddress + '/api/Extra/Search/MeridianCategories';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    /**
     * 获取经络详情数据
     * @param {any} success
     * @param {any} error
     */
    this.Detail = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/FoodPrescription/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
}

export { Meridian }
